export default {"src":"/_next/static/media/kitchen.c06956a0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};